import { styledWithProps } from '../../util/styles';
import Spinner from './Spinner';
import * as React from 'react';
import colors from '../colors';
import styled, { css } from 'styled-components';
import * as VideoIcon from 'react-icons/lib/io/eye-disabled';
import * as AudioIcon from 'react-icons/lib/io/ios-mic-off';
import * as CloseIcon from 'react-icons/lib/io/android-close';

interface Props {
    toggleVideo?: () => void;
    toggleAudio?: () => void;
    end: () => void;
    audioMuted: boolean;
    videoMuted: boolean;
}
interface State {}

class VideoControls extends React.Component<Props, State> {
    render() {
        return (
            <Wrapper>
                <ControlsWrapper>
                    <ButtonWrapper active={this.props.videoMuted}>
                        <Button onClick={this.props.toggleVideo}>
                            <StyledVideoIcon />
                        </Button>
                    </ButtonWrapper>
                    <ButtonWrapper active={this.props.audioMuted}>
                        <Button onClick={this.props.toggleAudio}>
                            <StyledAudioIcon />
                        </Button>
                    </ButtonWrapper>
                    <ButtonWrapper>
                        <Button onClick={this.props.end}>
                            <StyledCloseIcon />
                        </Button>
                    </ButtonWrapper>
                </ControlsWrapper>
            </Wrapper>
        );
    }
}

export default VideoControls;

const Wrapper = styled.div`
    position: absolute;
    top: 1em;
    left: 0;
    width: 100%;
    display: flex;
    z-index: 2;
`;

const ControlsWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    background-color: rgba(0, 0, 0, 0.7);
    border: 1px solid black;
    color: white;
    border-radius: 5px;
    overflow: hidden;
    width: 105px;
    margin: 0 auto;
    z-index: 2;
`;

const ButtonWrapper = styledWithProps<{ active?: boolean }>(styled.div)`
    z-index: 2;
    padding: 0 0.25em;
    border-right: 1px solid black;
    ${(props: any) => props.active && css`background-color: ${colors.red};`}
    &:last-child {
        border-right: 0;
        button {
            color: ${colors.red};
        }
    }
`;

const Button = styled.button`
    border: 0;
    background-color: transparent;
    color: white;
    font-size: 1.2em;
    line-height: normal;
    transition: all 0.15s;
    cursor: pointer;
    height: initial;
    padding: 3px 6px;
    margin: 0;
    &:focus {
        outline: none;
    }
    &:hover {
        transform: scale(1.3);
    }
    &:hover,
    &:focus {
        color: white;
    }
`;

const StyledVideoIcon = styled(VideoIcon)`
    display: inline-block;
    width: 15px;
`;
const StyledAudioIcon = styled(AudioIcon)`
    display: inline-block;
    width: 15px;
`;
const StyledCloseIcon = styled(CloseIcon)`
    display: inline-block;
    width: 15px;
`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Shared/VideoControls.tsx